import { None, Some } from "../../../../lib/misc/option";
import { BucketContainer } from "./BucketContainer";
import { Domain } from "./Domain";
export class ParameterUpdater {
    static create(layer) {
        let layer_defs = layer.group_layers.filter(def => /\d+/.test(def.label));
        if (layer_defs.length === 0)
            return None.instance();
        return new Some(new ParameterUpdater(layer));
    }
    constructor(layer) {
        this.layer = layer;
        let layer_defs = layer.group_layers.filter(def => /\d+/.test(def.label));
        let field = layer.field;
        this.domain = new Domain(field);
        this.buckets = new BucketContainer(layer_defs);
        this.update_layer_params();
    }
    get_bucket(label) {
        return this.buckets.get_bucket_by_label(label);
    }
    toggle_bucket(label, value) {
        const maybe_bucket = this.buckets.get_bucket_by_label(label);
        maybe_bucket.map(bucket => {
            if (value === true || value === false)
                bucket.visible = value;
            else
                bucket.visible = !bucket.visible;
        });
        this.update_layer_params();
    }
    clear() {
        this.buckets.as_array().forEach(bucket => bucket.visible = false);
        this.update_layer_params();
    }
    all_on() {
        this.buckets.as_array().forEach(bucket => bucket.visible = true);
        this.update_layer_params();
    }
    update_domain() {
        this.domain.clear();
        for (let bucket of this.buckets.as_array()) {
            if (bucket.visible)
                this.domain.union(bucket.interval);
        }
    }
    update_layer_params() {
        this.update_domain();
        let initial_params = this.layer.source.map(s => s.getParams()).unwrap();
        let layer_id = initial_params.layers.match(/\d+/g).map((n) => Number(n))[0];
        if (this.layer.source.isNone())
            return;
        if (this.buckets.as_array().length === 0) {
            initial_params.layerDefs = `{"${layer_id}: ${this.domain.toNone()}"}`;
        }
        else {
            let def = `{"${layer_id}": "${this.domain.toSQL()}"}`;
            initial_params.layerDefs = def;
        }
        this.layer.source.map(s => s.updateParams(initial_params));
        this.layer.changed();
    }
}
